import { Box, Link, useMediaQuery } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import tiktokIcon from '../../../assets/icons/tiktok.svg';
import React from 'react';
import theme from '../../../theme';

const contactNumbers = [
  "02-4067233",
  "02-4067234",
  "02-4065567",
  "02-4039110",
  "02-4039319",
  "09-782004472",
  "09-964065567",
  "09-404040577",
  "09-404040677",
  "09-952009123",
];

const ContactUsContactInformation = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        width: "90%",
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: isMobile ? 'center' : 'space-between',
        alignItems: isMobile ? 'center' : 'flex-start',
        gap: isMobile ? '20px' : '0', // Add spacing between boxes on mobile
      }}
    >
      <Box
        sx={{
          width: isMobile ? '100%' : '40%', // Full width on mobile
          height: "auto",
          paddingY: "20px",
          paddingX: isMobile? '5px' : "30px",
          borderRadius: "15px",
          backgroundColor: theme.palette.Card.main,
          textAlign: isMobile ? 'center' : 'left', // Center text on mobile
        }}
      >
        <p styled={{}}>Email Us</p>
        <p
          style={{
            lineHeight: "2",
            fontSize: isMobile ? "10px" : "16px",
          }}
        >
          Got a question or feedback? Drop us a line,<br /> we’ll get back to you within 24-48 hours.<br />Email:{" "}
          <Link href="mailto:mandalaywph258384@gmail.com" sx={{ color: "inherit", textDecoration: "none" }}>
            mandalaywph258384@gmail.com
          </Link>
        </p>
      </Box>

      <Box
        sx={{
          width: isMobile ? '100%' : '40%', // Full width on mobile
          height: "auto",
          paddingY: "20px",
          paddingX: isMobile? '5px' : "30px",
          borderRadius: "15px",
          border: `1.5px solid ${theme.palette.Card.main}`,
          textAlign: isMobile ? 'center' : 'left', // Center text on mobile
        }}
      >
        <p style={{ padding: 0, marginBottom: 0,  }}>Call Us</p>
        <p
          style={{
            lineHeight: "2",
            padding: 0,
            margin: 0,
            fontSize: isMobile ? "10px" : "16px",
          }}
        >
          Contact Numbers:{" "}
          {contactNumbers.map((number, index) => (
            <React.Fragment key={number}>
              <Link
                href={`tel:${number.replace(/[^\d]/g, "")}`}
                sx={{ color: "inherit", textDecoration: "none" }}
              >
                {number}
              </Link>
              {index < contactNumbers.length - 1 && ", "}
            </React.Fragment>
          ))}
          <br />
          Tik Tok:{" "}
          <Link
            href="https://www.tiktok.com/@mandalayiron?_r=1&_t=ZS-94NIRz4JYmb"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "inherit",
              textDecoration: "none",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <img src={tiktokIcon} alt="TikTok" style={{ width: 16, height: 16 }} />
            @mandalayiron
          </Link>
          <br />
          Facebook:{" "}
          <Link
            href="https://www.facebook.com/share/1GHAEMComL/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "inherit",
              textDecoration: "none",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <FacebookIcon sx={{ fontSize: 18 }} />
            Facebook Page
          </Link>
        </p>
      </Box>
    </Box>
  );
};

export default ContactUsContactInformation;
